import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Header, Message, Segment } from "semantic-ui-react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { RootStoreContext } from "../../../../app/stores/rootStore";

am4core.useTheme(am4themes_animated);

const StudentProgressbySubcategoryChart: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { studentProgressDevelopment } =
    rootStore.studentProgressDevelopmentStore;

  useEffect(() => {
    let chart = am4core.create("chartdiv", am4charts.XYChart);

    chart.data = studentProgressDevelopment;

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.minGridDistance = 50;
    dateAxis.dateFormats.setKey("day", "dd-MM");

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    let series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = "successPercentage";
    series.dataFields.dateX = "date";
    series.tensionX = 0.8;
    series.strokeWidth = 3;

    let bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.fill = am4core.color("#fff");
    bullet.circle.strokeWidth = 3;
    bullet.tooltipText =
      "{date}\nQuestões resolvidas: {totalAnswers}\n[bold]Sucesso: {valueY}%[/]";

    chart.cursor = new am4charts.XYCursor();
    chart.cursor.fullWidthLineX = true;
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineX.strokeWidth = 0;
    chart.cursor.lineX.fill = am4core.color("#000");
    chart.cursor.lineX.fillOpacity = 0.1;

    let range = valueAxis.axisRanges.create();
    range.value = 60;
    range.grid.stroke = am4core.color("#21ba45");
    range.grid.strokeWidth = 2;
    range.grid.strokeOpacity = 1;
    range.grid.strokeDasharray = "3,3";
    range.label.inside = true;
    range.label.text = "Sucesso";
    range.label.fill = range.grid.stroke;
    range.label.verticalCenter = "bottom";
  });

  return (
    <Segment>
      <Header textAlign="center">Evolução do Desempenho</Header>
      {studentProgressDevelopment.length > 0 ? (
        <div id="chartdiv" style={{ width: "100%", height: "300px" }}></div>
      ) : (
        <Message
          icon="warning circle"
          header="Oops"
          content="Ainda não há dados suficientes"
        />
      )}
    </Segment>
  );
};

export default observer(StudentProgressbySubcategoryChart);
